import { Enum } from '../../utils/enums'

export const ExpenseStatusEnumValues = [
  'Created',
  'Edited',
  'Deleted',
  'Submitted',
  'Approved',
  'Denied',
]
export const ExpenseStatus = Enum(
  'Created',
  'Edited',
  'Deleted',
  'Submitted',
  'Approved',
  'Denied'
)
